import styled from 'styled-components';

export const StyledContent = styled.div`
  background-color: #fff;
  padding: 1em 50px;

  @media (max-width: 768px) {
    padding: 1em 1em;
  }
`;

export type ImgIconsLegalProps = { src: string | undefined };

export const ImgIconsLegal = styled.img.attrs<ImgIconsLegalProps>((props: ImgIconsLegalProps) => ({
  src: props.src,
}))`
  flex-grow: 0;
  object-fit: contain;
`;

export const ButtonsWrapper = styled.div`
  display: block;
  text-align: center;
  margin: 3em auto 0 auto;
  max-width: 350px;
`;

export const AccessibilityLink = styled.a`
  display: block;
  margin-top: 1em;
  font-size: 12px;
  color: #6c757d;
  text-align: center;
`;
